import {
    Modal,
    generateResolver,
    yup,
    Notification,
    STATUS_TYPES,
} from "dyl-components";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Form, Icon } from "semantic-ui-react";
import contactsActions from "actions/contacts";
import { StringUtils } from "utils";

const AddToCampaignModal = ({
    open,
    onClose,
    contactToAdd,
    refresh
}) => {

    const {
        control,
        reset,
        formState: { isValid, isDirty },
        handleSubmit,
    } = useForm({
        mode: "onChange",
        defaultValues: {
            campaign: null,
        },
        resolver: generateResolver({
            campaign: yup.number().required("This field is required"),
        }),
    });

    const {
        campaigns,
        isReadingCampaigns,
        bulkAction,
    } = useSelector((state) => {
        return {
            campaigns: state.campaigns.campaigns,
            isReadingCampaigns: state.campaigns.isReadingCampaigns,
            bulkAction: state.contacts.bulkAction,
        };
    });
    const dispatch = useDispatch();

    const close = () => {
        reset();
        onClose();
    };

    const onBulkAction = async ({ campaign }) => {
        try {
            await dispatch(
                contactsActions.contactBulkAction(
                    {
                        action: "add_to_campaign",
                        contact_id: [contactToAdd],
                        campaign_id: campaign,
                    }
                )
            );
            close();
            if (refresh) {
                refresh();
            }
            Notification.alert("Successfully added to campaign!", STATUS_TYPES.SUCCESS);
        } catch (error) {
            console.log(error);
            Notification.alert("Failed to add to campaign", STATUS_TYPES.ERROR);
        }
    };

    const isAddingToCampaign = bulkAction === "add_to_campaign";
    return (
        <Modal open={open} onClose={close}>
            <Modal.Header>
                Add to Campaign
            </Modal.Header>
            <Modal.Content>
                <Form noValidate loading={isAddingToCampaign}>
                    <Controller
                        name="campaign"
                        control={control}
                        render={({ field: { name, value, onChange } }) => (
                            <Form.Select
                                value={value}
                                options={campaigns
                                    .map((campaign) => ({
                                        key: campaign.id,
                                        text: campaign.name,
                                        value: campaign.id,
                                        description: StringUtils.capitalize(campaign.campaign_conversion)
                                    }))}
                                onChange={(_, { value }) => {
                                    onChange({ target: { name, value } });
                                }}
                                placeholder={
                                    <div>
                                        <Icon
                                            style={{ marginRight: 10 }}
                                            name="search"
                                        />
                                        Select an Existing Campaign
                                    </div>
                                }
                                label="Campaign Name"
                                loading={isReadingCampaigns}
                                search
                                width={15}
                                selection
                                required
                                selectOnBlur={false}
                                clearable
                            />
                        )}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions
                hasSaveButton
                saveDisabled={!isValid || !isDirty || isAddingToCampaign}
                onSave={handleSubmit(onBulkAction)}
                saveOptions={{ loading: isAddingToCampaign }}
            />
        </Modal>
    );
};

export default AddToCampaignModal;
